var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 28,
    height: 15,
    rx: 2,
    fill: "#4A78ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 16V23H11.8C14.28 23 15.48 21.53 15.48 19.5C15.48 17.47 14.28 16 11.8 16H9.35ZM14.32 19.5C14.32 21.07 13.45 21.96 11.79 21.96H10.49V17.04H11.79C13.45 17.04 14.32 17.93 14.32 19.5ZM16.3121 19.5C16.3121 21.35 17.5221 23.13 19.9921 23.13C22.4521 23.13 23.6721 21.35 23.6721 19.5C23.6721 17.65 22.4521 15.87 19.9921 15.87C17.5221 15.87 16.3121 17.65 16.3121 19.5ZM22.5121 19.5C22.5121 20.84 21.6921 22.06 19.9921 22.06C18.3021 22.06 17.4721 20.84 17.4721 19.5C17.4721 18.16 18.3021 16.94 19.9921 16.94C21.6921 16.94 22.5121 18.16 22.5121 19.5ZM24.4962 19.56C24.4862 21.95 26.4062 23.13 28.2162 23.13C28.9562 23.13 29.6562 22.96 30.2462 22.67V21.54C29.7862 21.89 29.1362 22.08 28.4162 22.08C27.0762 22.08 25.6562 21.28 25.6562 19.56C25.6662 17.71 27.0562 16.92 28.3962 16.92C29.0562 16.92 29.7062 17.1 30.1962 17.44V16.33C29.5962 16.03 28.9062 15.87 28.2062 15.87C26.3662 15.87 24.4962 17.07 24.4962 19.56Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.cb75e1c7276f88f25acf0f9ca59844a2.svg";
export { ForwardRef as ReactComponent };